import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/pessoal/inicio', label: 'Inicio' },
  { to: '/pessoal/caixa', label: 'Caixa' },
  { to: '/pessoal/alertas', label: 'Alertas' },
  { to: '/pessoal/insights', label: 'Insights' },
  { to: '/pessoal/patrimonio', label: 'Patrimonio' },
  { to: '/pessoal/contas', label: 'Contas' },
  { to: '/pessoal/cartoes', label: 'Cartoes' },
  { to: '/pessoal/metas', label: 'Metas' },
  { to: '/pessoal/revisao-semanal', label: 'Revisao' },
  { to: '/pessoal/conexoes', label: 'Conexoes' },
  { to: '/pessoal/ajustes', label: 'Ajustes' },
];

const tabClass = ({ isActive }) =>
  `rounded-full px-4 py-2 text-sm font-medium transition-colors ${
    isActive ? 'bg-slate-900 text-white' : 'bg-white text-slate-600 hover:bg-slate-100'
  }`;

const PersonalFinanceLayout = () => {
  return (
    <div className="animate-fade-in space-y-6">
      <section className="overflow-hidden rounded-[28px] border border-emerald-200 bg-[radial-gradient(circle_at_top_left,_rgba(52,211,153,0.24),_transparent_35%),linear-gradient(135deg,_#0f172a,_#111827_55%,_#1f2937)] p-6 text-white shadow-soft">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl space-y-3">
            <span className="inline-flex rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-emerald-100">
              Personal Finance Beta
            </span>
            <div>
              <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Financas pessoais com dominio proprio</h1>
              <p className="mt-2 max-w-xl text-sm text-slate-200 sm:text-base">
                O foco aqui e clareza diaria, forecast de caixa, cartoes, metas, patrimonio e agora um loop operacional com alertas acionaveis.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
              <p className="text-[11px] uppercase tracking-[0.18em] text-emerald-100">Slice</p>
              <p className="mt-2 text-lg font-semibold">Alertas</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
              <p className="text-[11px] uppercase tracking-[0.18em] text-emerald-100">Foco</p>
              <p className="mt-2 text-lg font-semibold">Ops Loop</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
              <p className="text-[11px] uppercase tracking-[0.18em] text-emerald-100">Proximo</p>
              <p className="mt-2 text-lg font-semibold">Tiering</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
              <p className="text-[11px] uppercase tracking-[0.18em] text-emerald-100">Estado</p>
              <p className="mt-2 text-lg font-semibold">Ativo</p>
            </div>
          </div>
        </div>
      </section>

      <div className="overflow-x-auto">
        <div className="flex min-w-max gap-2 rounded-full bg-slate-100 p-2">
          {tabs.map((tab) => (
            <NavLink key={tab.to} to={tab.to} className={tabClass}>
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>

      <Outlet />
    </div>
  );
};

export default PersonalFinanceLayout;
